// extracted by mini-css-extract-plugin
export default {"default":"styles_default__+3A0X","activeIcon":"styles_activeIcon__4VvcE","defaultIcon":"styles_defaultIcon__GyJ43","premiumBadge":"styles_premiumBadge__MRM3G"};